// extracted by mini-css-extract-plugin
export default {"donut-chart":"donut-chart-AlBuD","donut-chart__hole":"donut-chart__hole-BIbjT"};